/* clonar-landing-shopify · comportamiento del clon (galería, oferta, variantes, carrito, pestañas, acordeones) */
(function () {
  'use strict';
  if (window.__clxListo) return;
  window.__clxListo = true;

  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var producto = null;
  var tienda = { money: '{{amount_with_comma_separator}} €' };
  try { producto = JSON.parse(document.querySelector('script[data-clx-producto]').textContent); } catch (e) {}
  try { tienda = JSON.parse(document.querySelector('script[data-clx-tienda]').textContent); } catch (e) {}
  var raices = $$('.clx-root');
  if (!raices.length) return;
  var variantes = (producto && producto.variants) || [];
  var porId = {};
  variantes.forEach(function (v) { porId[String(v.id)] = v; });

  // ---------- dinero (mismo formato que la tienda) ----------
  function formato(cents, fmt) {
    if (cents === null || cents === undefined) return '';
    fmt = fmt || tienda.money || '{{amount}}';
    function num(n, dec, mil, sepdec) {
      n = (n / 100).toFixed(dec);
      var p = n.split('.');
      p[0] = p[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + mil);
      return p[1] ? p[0] + sepdec + p[1] : p[0];
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var tipo = m ? m[1] : 'amount';
    var val;
    switch (tipo) {
      case 'amount_no_decimals': val = num(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': val = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = num(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = num(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': val = num(cents, 2, ' ', ','); break;
      default: val = num(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val).replace(/<[^>]+>/g, '');
  }

  // ---------- variante seleccionada ----------
  function aplicarVariante(id, origen) {
    var v = porId[String(id)];
    if (!v) return;
    $$('form[data-clx-form] input[name="id"], form[data-clx-form] select[name="id"]').forEach(function (inp) { inp.value = v.id; });
    $$('[data-clx-precio="price"]').forEach(function (el) { el.textContent = formato(v.price); });
    $$('[data-clx-precio="compare"]').forEach(function (el) {
      el.textContent = v.compare_at_price > v.price ? formato(v.compare_at_price) : '';
    });
    $$('[data-clx-agotado]').forEach(function (el) { el.disabled = !v.available; });
    document.dispatchEvent(new CustomEvent('clx:variante', { detail: { variante: v, origen: origen } }));
  }

  function contenedor(inp) {
    return inp.closest('label') || inp.parentElement;
  }

  // clase "seleccionada" que usaba la competencia (la que tiene la opción marcada y no sus hermanas)
  function claseSeleccion(grupo) {
    var marcado = grupo.filter(function (i) { return i.checked; })[0];
    if (!marcado) return 'clx-seleccionada';
    var c = contenedor(marcado);
    var otras = grupo.filter(function (i) { return i !== marcado; }).map(contenedor);
    var propias = Array.prototype.slice.call(c.classList).filter(function (cl) {
      return otras.every(function (o) { return !o.classList.contains(cl); });
    });
    return propias.filter(function (cl) { return /select|active|check|current|chosen|on\b/i.test(cl); })[0] || propias[0] || 'clx-seleccionada';
  }

  var radios = $$('.clx-root input[type="radio"], .clx-root input[type="checkbox"]').filter(function (i) { return porId[String(i.value)]; });
  var grupos = {};
  radios.forEach(function (r) { (grupos[r.name || '_'] = grupos[r.name || '_'] || []).push(r); });
  Object.keys(grupos).forEach(function (n) {
    var g = grupos[n];
    var clase = claseSeleccion(g);
    g.forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        g.forEach(function (o) { contenedor(o).classList.remove(clase); });
        contenedor(r).classList.add(clase);
        aplicarVariante(r.value, r);
      });
    });
    var ini = g.filter(function (r) { return r.checked; })[0];
    if (ini) aplicarVariante(ini.value, ini);
  });
  // packs por cantidad: radios con data-clx-cantidad="2" (descuento automático en Shopify)
  var packs = $$('.clx-root input[data-clx-cantidad]');
  function aplicarPack(r) {
    var n = r.getAttribute('data-clx-cantidad') || '1';
    $$('form[data-clx-form] input[name="quantity"]').forEach(function (q) { q.value = n; });
    var bloque = r.closest('[data-clx-packs]') || document;
    $$('[data-clx-pack]', bloque).forEach(function (p) { p.classList.remove('is-selected'); });
    var item = r.closest('[data-clx-pack]');
    if (item) item.classList.add('is-selected');
    if (r.getAttribute('data-clx-variante')) aplicarVariante(r.getAttribute('data-clx-variante'), r);
    // precio del botón de compra = total del pack elegido (y su precio de antes)
    if (item && item.getAttribute('data-clx-total')) {
      var total = parseInt(item.getAttribute('data-clx-total'), 10);
      var antes = parseInt(item.getAttribute('data-clx-comp') || '0', 10);
      $$('[data-clx-precio="price"], form[data-clx-form] .gp-price.gp-money').forEach(function (el) { el.textContent = formato(total); });
      $$('[data-clx-precio="compare"], form[data-clx-form] .gp-product-compare-price').forEach(function (el) { el.textContent = antes > total ? formato(antes) : ''; });
    }
  }
  packs.forEach(function (r) {
    r.addEventListener('change', function () { if (r.checked) aplicarPack(r); });
    if (r.checked) aplicarPack(r);
  });
  $$('.clx-root select[name="id"]').forEach(function (s) {
    s.addEventListener('change', function () { aplicarVariante(s.value, s); });
  });

  // opciones por nombre (talla, color…): radios o selects cuyo valor es un valor de opción
  if (producto && producto.options && variantes.length > 1) {
    var opciones = producto.options.map(function (o) { return (o.values || []).map(String); });
    var campos = $$('.clx-root input[type="radio"], .clx-root select').filter(function (el) {
      if (porId[String(el.value)] || el.name === 'id') return false;
      return opciones.some(function (vals) { return vals.indexOf(String(el.value)) >= 0; });
    });
    function indiceOpcion(el) {
      var vals = el.tagName === 'SELECT' ? $$('option', el).map(function (o) { return o.value; }) : [el.value];
      for (var i = 0; i < opciones.length; i++) {
        if (vals.some(function (v) { return opciones[i].indexOf(String(v)) >= 0; })) return i;
      }
      return -1;
    }
    function recalcular() {
      var sel = [];
      campos.forEach(function (el) {
        var i = indiceOpcion(el);
        if (i < 0) return;
        if (el.tagName === 'SELECT' || el.checked) sel[i] = String(el.value);
      });
      var v = variantes.filter(function (va) {
        return (va.options || []).every(function (o, i) { return sel[i] === undefined || String(o) === sel[i]; });
      })[0];
      if (v) aplicarVariante(v.id, null);
    }
    campos.forEach(function (el) { el.addEventListener('change', recalcular); });
  }

  // ---------- añadir al carrito ----------
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  $$('form[data-clx-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"], button[name="add"]');
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
      var datos = new FormData(form);
      var cant = form.querySelector('[data-clx-cantidad]:checked');
      if (cant) datos.set('quantity', cant.getAttribute('data-clx-cantidad') || '1');
      fetch(raiz + 'cart/add.js', { method: 'POST', body: datos, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Error');
          if (form.getAttribute('data-clx-form') !== 'checkout' && window.__clxCarrito) {
            if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
            window.__clxCarrito.abrir();
            return;
          }
          window.location.href = raiz + (form.getAttribute('data-clx-form') === 'checkout' ? 'checkout' : 'cart');
        })
        .catch(function (err) {
          if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
          alert(err.message || 'No se pudo añadir al carrito');
        });
    });
  });

  // ---------- botones "comprar" que llevan a la oferta ----------
  $$('a[href="#clx-comprar"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var d = document.getElementById('clx-comprar');
      if (!d) return;
      e.preventDefault();
      d.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // ---------- galerías y carruseles ----------
  function desplazable(el) { return el && el.scrollWidth > el.clientWidth + 8; }
  function pista(cerca) {
    var c = cerca;
    for (var i = 0; i < 5 && c; i++) {
      var s = c.querySelector('.slider, .swiper, .product__media-list, [id^="Slider-"], .flickity-slider, .slick-track, .gallery, [class*="carousel"] ul, [class*="slider"] ul');
      if (s && desplazable(s)) return s;
      c = c.parentElement;
    }
    return null;
  }
  $$('.clx-root .slider-button--next, .clx-root .slider-button--prev, .clx-root .swiper-button-next, .clx-root .swiper-button-prev, .clx-root [name="next"], .clx-root [name="previous"], .clx-root [class*="arrow-next"], .clx-root [class*="arrow-prev"], .clx-root [class*="next-arrow"], .clx-root [class*="prev-arrow"]').forEach(function (b) {
    b.removeAttribute('disabled');
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var s = pista(b.parentElement);
      if (!s) return;
      var dir = /next/i.test((b.className || '') + ' ' + (b.getAttribute('name') || '')) ? 1 : -1;
      var fin = s.scrollLeft + s.clientWidth >= s.scrollWidth - 4;
      if (dir > 0 && fin) s.scrollTo({ left: 0, behavior: 'smooth' });
      else if (dir < 0 && s.scrollLeft <= 4) s.scrollTo({ left: s.scrollWidth, behavior: 'smooth' });
      else s.scrollBy({ left: dir * s.clientWidth, behavior: 'smooth' });
    });
  });
  // miniaturas (Dawn/Shrine y derivados)
  $$('.clx-root [data-target], .clx-root .thumbnail-list button, .clx-root [class*="thumbnail"] button').forEach(function (t) {
    t.addEventListener('click', function (e) {
      var obj = t.getAttribute('data-target');
      var raizSec = t.closest('.clx-root');
      var destino = obj ? raizSec.querySelector('[data-media-id="' + obj + '"]') : null;
      if (!destino) {
        var item = t.closest('li');
        var lista = item && item.parentElement ? $$(':scope > li', item.parentElement) : [];
        var idx = lista.indexOf(item);
        var s0 = raizSec.querySelector('.product__media-list, .slider, .swiper-wrapper');
        destino = s0 && idx >= 0 ? s0.children[idx] : null;
      }
      if (!destino) return;
      e.preventDefault();
      var s = destino.parentElement;
      if (desplazable(s)) s.scrollTo({ left: destino.offsetLeft - s.offsetLeft, behavior: 'smooth' });
      else destino.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      $$('[aria-current]', t.closest('ul') || raizSec).forEach(function (o) { o.removeAttribute('aria-current'); });
      t.setAttribute('aria-current', 'true');
    });
  });
  // contador "1 / 5" y puntos
  $$('.clx-root .slider-counter--current').forEach(function (cnt) {
    var s = pista(cnt.parentElement);
    if (!s) return;
    s.addEventListener('scroll', function () {
      cnt.textContent = Math.round(s.scrollLeft / Math.max(1, s.clientWidth)) + 1;
    }, { passive: true });
  });

  // ---------- galería de producto tipo GemPages (imagen grande + miniaturas con flechas) ----------
  $$('.clx-root clx-gp-carousel-v3[type="gp-feature-image-carousel"]').forEach(function (cm) {
    var raizG = cm.closest('.clx-root');
    var cg = raizG.querySelector('clx-gp-carousel-v3[type="grid-carousel"]');
    var wm = cm.querySelector('.gem-slider-wrapper');
    var wt = cg && cg.querySelector('.gem-slider-wrapper');
    if (!wm) return;
    var n = wm.children.length, idx = 0;
    function paso(w) {
      if (w.children.length < 2) return w.children[0] ? w.children[0].getBoundingClientRect().width : 0;
      return w.children[1].getBoundingClientRect().left - w.children[0].getBoundingClientRect().left;
    }
    function mover(w, px) { w.style.transition = 'transform .3s ease'; w.style.transform = 'translateX(' + (-px) + 'px)'; }
    function ir(i) {
      idx = (i + n) % n;
      mover(wm, idx * paso(wm));
      if (wt) {
        var p = paso(wt), vis = Math.max(1, Math.floor((wt.parentElement.getBoundingClientRect().width + (p - wt.children[0].getBoundingClientRect().width)) / p));
        var off = Math.min(Math.max(0, idx - Math.floor(vis / 2)), Math.max(0, n - vis));
        mover(wt, off * p);
        Array.prototype.forEach.call(wt.children, function (t, j) {
          if (j === idx) t.setAttribute('data-outline', 'active'); else t.removeAttribute('data-outline');
        });
      }
    }
    if (wt) {
      Array.prototype.forEach.call(wt.children, function (t, j) { t.addEventListener('click', function () { ir(j); }); });
      $$('button[aria-label]', cg).forEach(function (b) {
        var sig = /gem-slider-next|siguiente|next/i.test(b.className + ' ' + b.getAttribute('aria-label'));
        b.style.visibility = 'visible';
        b.style.display = 'flex';
        b.style.cursor = 'pointer';
        b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); ir(idx + (sig ? 1 : -1)); });
      });
    }
    // deslizar con el dedo en la imagen grande
    var x0 = null;
    cm.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    cm.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) ir(idx + (dx < 0 ? 1 : -1));
    });
    ir(0);
    window.addEventListener('resize', function () { ir(idx); });
  });

  // ---------- pestañas ----------
  $$('.clx-root [role="tablist"]').forEach(function (lista) {
    var tabs = $$('[role="tab"]', lista);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        tabs.forEach(function (o) {
          o.setAttribute('aria-selected', o === tab ? 'true' : 'false');
          o.classList.toggle('active', o === tab);
          o.classList.toggle('is-active', o === tab);
          var p = document.getElementById(o.getAttribute('aria-controls'));
          if (p) { p.hidden = o !== tab; p.classList.toggle('active', o === tab); p.classList.toggle('is-active', o === tab); }
        });
      });
    });
  });
  $$('.clx-root [data-tab], .clx-root .tab-link, .clx-root .tabs__title, .clx-root [class*="tab-button"], .clx-root [class*="tab__button"]').forEach(function (tab) {
    if (tab.closest('[role="tablist"]')) return;
    tab.addEventListener('click', function (e) {
      var cont = tab.parentElement;
      var hermanos = $$(':scope > *', cont);
      var idx = hermanos.indexOf(tab);
      var raizT = cont.parentElement;
      var paneles = [];
      for (var i = 0; i < 4 && raizT && !paneles.length; i++) {
        paneles = $$('.tab-content > *, .tabs__content > *, [data-tab-content], .tab-pane, [class*="tab-panel"], [class*="tab__content"]', raizT);
        raizT = raizT.parentElement;
      }
      if (!paneles.length || idx < 0) return;
      e.preventDefault();
      var activa = hermanos.filter(function (h) { return /active|current|selected/.test(h.className); })[0];
      var clase = activa ? (activa.className.match(/[\w-]*(active|current|selected)[\w-]*/) || ['active'])[0] : 'active';
      hermanos.forEach(function (h) { h.classList.toggle(clase, h === tab); });
      paneles.forEach(function (p, j) {
        var on = j === idx;
        p.classList.toggle(clase, on);
        p.style.display = on ? '' : 'none';
        p.hidden = !on;
      });
    });
  });

  // pestañas emparejadas por atributo (data-index, data-tab…): botón ↔ panel con el mismo valor
  ['data-index', 'data-tab', 'data-tab-index', 'data-tab-id', 'data-id'].forEach(function (attr) {
    var botones = $$('.clx-root button[' + attr + '], .clx-root a[' + attr + '], .clx-root li[' + attr + '], .clx-root [class*="tab"][' + attr + ']')
      .filter(function (b) {
        return /tab|button|btn|title|nav/i.test(b.className + ' ' + b.tagName) && !b.closest('[role="tablist"]') &&
          !b.querySelector('img, video') && (b.textContent || '').trim().length > 0 &&
          !b.closest('[class*="slider"], [class*="gallery"], [class*="thumbnail"], [class*="swiper"], [class*="carousel"]');
      });
    var porPadre = new Map();
    botones.forEach(function (b) { var p = b.parentElement; if (!porPadre.has(p)) porPadre.set(p, []); porPadre.get(p).push(b); });
    porPadre.forEach(function (grupo, padre) {
      if (grupo.length < 2) return;
      var raizSec = padre.closest('.clx-root');
      var paneles = $$('[' + attr + ']', raizSec).filter(function (el) {
        return grupo.indexOf(el) < 0 && !padre.contains(el) && !el.closest('button') &&
          !el.closest('[class*="slider"], [class*="gallery"], [class*="swiper"], [class*="carousel"]');
      });
      if (!paneles.length) return;
      function claseActiva(lista) {
        for (var i = 0; i < lista.length; i++) {
          var m = (lista[i].className || '').match(/[\w-]*(active|current|selected|open)[\w-]*/);
          if (m) return m[0];
        }
        return 'is-active';
      }
      var cb = claseActiva(grupo), cp = claseActiva(paneles);
      // fondo deslizante del botón activo (lo movía el JS del tema original)
      var indicador = $$(':scope > *', padre).filter(function (el) {
        return grupo.indexOf(el) < 0 && /active-?bg|active-background|indicator|highlight|pill|slider-bg|tab-bg|underline/i.test(el.className || '') &&
          getComputedStyle(el).position === 'absolute';
      })[0];
      function moverIndicador() {
        if (!indicador) return;
        var act = grupo.filter(function (o) { return o.classList.contains(cb); })[0] || grupo[0];
        indicador.style.left = act.offsetLeft + 'px';
        indicador.style.top = act.offsetTop + 'px';
        indicador.style.width = act.offsetWidth + 'px';
        indicador.style.height = act.offsetHeight + 'px';
        indicador.style.transform = 'none';
      }
      moverIndicador();
      window.addEventListener('resize', moverIndicador);
      grupo.forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var val = b.getAttribute(attr);
          grupo.forEach(function (o) { o.classList.toggle(cb, o === b); o.setAttribute('aria-selected', o === b ? 'true' : 'false'); });
          moverIndicador();
          paneles.forEach(function (p) {
            var on = p.getAttribute(attr) === val;
            p.classList.toggle(cp, on);
            p.hidden = false;
            p.style.display = '';
            if (!on && getComputedStyle(p).display !== 'none') p.style.display = 'none';
          });
        });
      });
    });
  });

  // ---------- acordeones que no usan <details> ----------
  $$('.clx-root [aria-expanded][aria-controls]').forEach(function (btn) {
    if (btn.getAttribute('role') === 'tab') return;
    btn.addEventListener('click', function (e) {
      var p = document.getElementById(btn.getAttribute('aria-controls'));
      if (!p) return;
      e.preventDefault();
      var abrir = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', abrir ? 'true' : 'false');
      p.hidden = !abrir;
      p.style.display = abrir ? '' : 'none';
      p.style.maxHeight = abrir ? 'none' : '';
    });
  });
  $$('.clx-root [class*="accordion"] [class*="title"], .clx-root [class*="accordion"] [class*="header"], .clx-root [class*="faq"] [class*="question"], .clx-root .collapsible-trigger').forEach(function (h) {
    if (h.closest('details') || h.hasAttribute('aria-controls')) return;
    var panel = h.nextElementSibling;
    if (!panel) return;
    h.style.cursor = 'pointer';
    h.addEventListener('click', function () {
      var item = h.parentElement;
      var abierto = item.classList.toggle('is-open');
      item.classList.toggle('active', abierto);
      item.classList.toggle('open', abierto);
      panel.style.display = abierto ? 'block' : 'none';
      panel.style.maxHeight = abierto ? 'none' : '';
      panel.style.height = abierto ? 'auto' : '';
    });
  });

  // ---------- botones de cantidad ----------
  $$('.clx-root .quantity__button, .clx-root [name="plus"], .clx-root [name="minus"]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      var inp = (b.closest('.quantity, [class*="quantity"]') || b.parentElement).querySelector('input[type="number"], input[name="quantity"]');
      if (!inp) return;
      e.preventDefault();
      var v = parseInt(inp.value || '1', 10) + (b.getAttribute('name') === 'minus' || /minus/.test(b.className) ? -1 : 1);
      inp.value = Math.max(1, v);
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // ---------- botones fuera del formulario (barra fija) que apuntan a él con form="…" ----------
  $$('.clx-root button[form], .clx-root input[type="submit"][form]').forEach(function (b) {
    var f = document.getElementById(b.getAttribute('form'));
    if (!f || !f.hasAttribute('data-clx-form')) return;
    b.addEventListener('click', function (e) {
      e.preventDefault();
      if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  });

  // ---------- barra de compra fija: aparece al pasar el botón principal ----------
  var ancla = document.getElementById('clx-comprar');
  var fijas = $$('.clx-root [class*="sticky"]').filter(function (el) {
    var cs = getComputedStyle(el);
    return cs.position === 'fixed' && !el.parentElement.closest('[class*="sticky"]');
  });
  if (ancla && fijas.length && 'IntersectionObserver' in window) {
    var objetivo = ancla.nextElementSibling || ancla.parentElement;
    new IntersectionObserver(function (ent) {
      var mostrar = !ent[0].isIntersecting && ent[0].boundingClientRect.top < 0;
      fijas.forEach(function (f) {
        f.style.transform = mostrar ? 'translateY(0)' : '';
        f.style.visibility = mostrar ? 'visible' : '';
        f.setAttribute('data-clx-visible', mostrar ? 'true' : 'false');
      });
    }).observe(objetivo);
  }
})();
